import React from 'react';
import { Link } from 'react-router-dom';
import './DashboardNavCard.css';

export type DashboardNavCardProps = {
  title: string;
  description: string;
  /** Bootstrap icon class without the leading `bi `, e.g. `bi-shield-lock` or full `bi bi-shield-lock` */
  icon: string;
  to: string;
  actionLabel: string;
  className?: string;
};

const DashboardNavCard: React.FC<DashboardNavCardProps> = ({
  title,
  description,
  icon,
  to,
  actionLabel,
  className = '',
}) => {
  const iconClass = icon.includes('bi ') || icon.startsWith('bi-') ? (icon.startsWith('bi ') ? icon : `bi ${icon}`) : `bi ${icon}`;

  return (
    <div className={`card h-100 shadow-sm dashboard-nav-card ${className}`.trim()}>
      <div className="card-body d-flex flex-column">
        <div className="d-flex align-items-start gap-3 mb-3">
          <div className="dashboard-nav-card__icon-wrap flex-shrink-0" aria-hidden>
            <i className={`${iconClass} fs-4`} />
          </div>
          <div className="dashboard-nav-card__copy min-w-0">
            <h2 className="h5 mb-2 dashboard-nav-card__title">{title}</h2>
            <p className="text-muted small mb-0 dashboard-nav-card__desc">{description}</p>
          </div>
        </div>
        <div className="mt-auto pt-1">
          <Link to={to} className="btn btn-primary">
            {actionLabel}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardNavCard;
